<div class="card">
  <div class="card-header">
    <h5>View Discount</h5>
  </div>
  <div class="card-body">
    <div style="display: flex; justify-content: flex-end; align-items: center;">
      <button class="btn btn-light" style="background-color: #5864FF; color: white;" (click)="load()">Refresh</button>
    </div>
    <div class="container" style="width: 500px;">
      <form name="discountForm" (submit)="updateDiscount()">
        <div>
          <label>Account ID</label>
          <input class="form-control" name="accountID" type="text" [ngModel]="accountId" disabled>
        </div>
        <div>
          <label>Date Range</label>
          <input class="form-control" name="dateRange" type="text" id="dateRange" [(ngModel)]="dateRange">
        </div>
        <div>
          <label>Discount (%)</label>
          <input class="form-control" name="discountRate" type="text" [(ngModel)]="discount">
        </div>
        <div>
          <button class="btn btn-light" style="background-color: #5864FF; color: white;" type="submit">Submit</button>
        </div>
      </form>
    </div>
  </div>
</div>

<style>
  form div {
    margin: 10px 0;
  }
</style>